<template lang="pug">
  .scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tabHead")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
        tbody.table__body(v-for="item in tabData")
          tr.table__row
            td.table__cell
              .table__cell-content {{item.name}}
            td.table__cell
              .table__cell-content {{ item.capacity }}
            td.table__cell.fixed
              .table__cell-content.table__cell-content_align-right(
                v-if="!item.disabled"
              )
                button.button.button_square.table__cell-control(
                @click.prevent="onEditCampHouse(item)"
                )
                  img(src="@/assets/images/icons/icon-edit.svg")
                button.button.button_square.table__cell-control(
                @click.prevent="onDeleteCampHouse(item)"
                )
                  img(src="@/assets/images/icons/trash.svg")
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "ManagerCampHousesRegistryScrollFixTable",
  props: [
    "tab-data",
    "tab-head"
  ],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  },
  methods: {
    onEditCampHouse(house) {
      this.$emit("on-edit-camp-house", house);
    },
    onDeleteCampHouse(house) {
      this.$emit("on-delete-camp-house", house);
    }
  }
};
</script>
